"use client";

import React, { useEffect, useState } from "react";
import LABELS from "@/components/global-constant/src/general";

import { fetchHomePageMinimalData, HomePageMinimalSectionShell } from "@/api-service/homePage";
import LazySectionShell from "../components/homepage/LazySectionShell";

export default function HomePage() {
  const [shells, setShells] = useState<HomePageMinimalSectionShell[]>([]);

  useEffect(() => {
    let isMounted = true;
    const loadHomePageMinimal = async () => {
      try {
        const res = await fetchHomePageMinimalData();
        if (isMounted && res?.data?.sections) {
          setShells(res.data.sections);
        }
      } catch (err) {
        console.error("Failed to load minimal home page sections:", err);
      }
    };

    loadHomePageMinimal();
    return () => {
      isMounted = false;
    };
  }, []);

  const jsonLd = {
    "@context": "http://schema.org",
    "@type": "Organization",
    "name": LABELS.ORGANIZATION.NAME,
    "logo": LABELS.ORGANIZATION.LOGO,
    "url": LABELS.ORGANIZATION.URL,
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />
      <section className="w-full mx-auto">
        {/* Dynamic Home Page Sections (Lazy Loaded on Scroll with Skeleton UI) */}
        {shells.map((shell, index) => (
          <LazySectionShell key={shell.id} shell={shell} isFirst={index === 0} />
        ))}
      </section>
    </>
  );
}
